import React, {useState, useEffect} from 'react';
import './style/Project.css';
import anniversary_logo from "../imgs/4anniversary.png";
import game_logo from "../imgs/game.png";
import enjoy_logo from "../imgs/enjoy.png";
import pedidos from "../imgs/pedidos.png";
import fruvi from "../imgs/fruvi.png";
import usa from "../imgs/usa.png";
import eduPlataform from "../imgs/eduPlataform.png";




function Project({projectName}){
 
    const [title, setTitle] = useState('');
    const [tec, setTec] = useState('');
    const [date, setDate] = useState('');
    const [url, setUrl] = useState('');
    const [urlCode, setUrlCode] = useState('');
    const [txtDescription, setTxtDescription] = useState('');
    const [img, setImg] = useState('');


    useEffect(() => {
            switch (projectName) {
              case 'Education plataform':
                    setTitle(projectName);
                    setTec('React js - Next.js/ Redux Redux-saga/ Js/ HTML5/ CSS3/ Responsive web Design');
                    setDate('01/11/2022');
                    setUrl('https://test-react-education-plataform.vercel.app/');
                    setUrlCode('https://github.com/garcia98daniel/test-react-education-plataform');
                    setTxtDescription(`Building this beautiful layout as my own challenge.`);
                    setImg(eduPlataform);
                    break;
              case 'Fruvi eCommerce':
                    setTitle(projectName);
                    setTec('React js - Next.js/ Redux Redux-saga/ Js/ HTML5/ CSS3/ Responsive web Design/ eCommerce');
                    setDate('08/06/2021');
                    setUrl('https://www.fruvi.co/');
                    setUrlCode('Private');
                    setTxtDescription(`This spectacular ecommerce was made to Netgou company client. was a very good challenge for me to improve my code skills and get more experience with React library.`);
                    setImg(fruvi);
                    break;
              case 'Usa machinery':
                    setTitle(projectName);
                    setTec('React js - Gatsby.js/ Js/ HTML5/ CSS3/ Responsive web Design');
                    setDate('28/04/2021');
                    setUrl('https://www.usamachinery.com.mx/');
                    setUrlCode('Private');
                    setTxtDescription(`This page was made for a happer company client.`);
                    setImg(usa);
                    break;
              case 'Order Pizza':
                    setTitle(projectName);
                    setTec('React js/ Laravel(php)/ DB MySQL/ Pusher/ Js/ HTML5/ CSS3/ Responsive Design/ real time');
                    setDate('28/12/2020');
                    setUrl('https://entreamigos.vercel.app/');
                    setUrlCode('https://github.com/garcia98daniel/OrderPizza');
                    setTxtDescription(`This project was made to help my brother's pizza shop in order to make easier to get pizza orders through whatsapp or instagram asking orders details to the people.`);
                    setImg(pedidos);
                    break;
                case 'EnjoyItBeach':
                    setTitle(projectName);
                    setTec('Laravel(php)/ DB MySQL/ Ajax/ Js/ HTML5/ CSS3/ Responsive Design');
                    setDate('12/11/2019');
                    setUrl('http://enjoybeach.herokuapp.com/Login');
                    setUrlCode('https://github.com/garcia98daniel/enjoyItBeach');
                    setTxtDescription(`EnjoyItBeach was a project created with the Laravel framework to be financed in apps.co competition, unfortunately I didn't win but I learn a lot about this technology. I leave the link here, check it out.`);
                    setImg(enjoy_logo);
                    break;
                case '4anniversary':
                    setTitle(projectName);
                    setTec('ReactJs/ Js/ HTML5/ CSS3/ Responsive Design');
                    setDate('23/06/2020');
                    setUrl('https://garcia98daniel.github.io/4anniversary/');
                    setUrlCode('https://github.com/garcia98daniel/4anniversary');
                    setTxtDescription(`This page was made with love to my girlfriend Daniela A. she is a very special person that I love so much. In this project I had a lot of fun and also I practiced with the react library implementing hooks.`);
                    setImg(anniversary_logo);

                    break;
                case 'Simon-says-Game---JS':
                    setTitle(projectName);
                    setTec('Java Script/ HTML5/ CSS3/ Responsive Design');
                    setDate('15/06/2020');
                    setUrl('https://garcia98daniel.github.io/Simon-says-Game---JS/');
                    setUrlCode('https://github.com/garcia98daniel/Simon-says-Game---JS');
                    setTxtDescription(`This is my first game made with java script lenguaje. Very basic game made with love, enjoy. available for all devices.`);
                    setImg(game_logo);
        
                    break;
                default:
                    break;
            }
    },[]);

    return (
        <article className="project">
                      <div className="description">
                        <h2 className="project_tittle">{title}</h2>
                        <small>{tec}</small>
                        <p>
                          <strong>Date:</strong><small>{date}</small>
                        </p>
                        <p>
                          <strong>Check it out here: <a className="links-project" href={url}>{url}</a></strong>
                        </p>
                        <p>
                          <strong>Code: <a className="links-project" href={urlCode}>{urlCode}</a></strong>
                        </p>
                        <p className="project-description">
                          {txtDescription}
                        </p>
                      </div>
                      <figure className="project-imageContainer">
                        <a  href={url}>
                          <img className="project-image" src={img} alt={title}/>
                        </a>
                      </figure>
        </article>
    );
}

export default Project;
